import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service/';
import Global from '../../../../../store/global-selectors';
import { FiltersContext } from '../../../../../filters/context';
import ActionableFilterPill from '../../../../../components/actionable-filter-pill';

import messages from '../messages';

// note: this is a reskin of assignedTo, that should eventually get its own column/filter.
const PROCESSED_BY_ID = 'assignedTo';
const NONE_GUID = '00000000-0000-0000-0000-000000000000';

const getDisplayName = (appliedFilters, users) => {
  if (appliedFilters.length === 0) {
    return <FormattedMessage {...messages.assignee} />;
  }
  if (appliedFilters.length > 1) {
    return <FormattedMessage {...messages.multipleUsers} />;
  }
  const [value] = appliedFilters;
  if (value === NONE_GUID) {
    return <FormattedMessage {...messages.unassigned} />;
  }

  const matchingUser = users.find((user) => user.userId === value);
  return matchingUser?.name ?? <FormattedMessage {...messages.assignee} />;
};

const getUserName = (users, userId) => {
  const user = users.find((u) => u.userId === userId);
  return user?.name ?? '';
};

const ProcessedByActionableFilterPill = React.forwardRef((props, ref) => {
  const { filters } = useContext(FiltersContext);
  const appliedFilters = filters.find((filter) => filter.id === PROCESSED_BY_ID)?.value ?? [];
  const users = useSelector(Global.selectSellerUsers);
  const currentUserId = useSelector(Global.selectUserCurrentUserId);
  const isUserLocked = useSelector(Global.selectUseruserHasShipmentViewRestriction);
  const isSelected = appliedFilters.length > 0;
  const displayContent = isUserLocked ? getUserName(users, currentUserId) : getDisplayName(appliedFilters, users);

  return <ActionableFilterPill {...props} ref={ref} displayContent={displayContent} isLocked={isUserLocked} isSelected={isSelected} />;
});

export default {
  id: PROCESSED_BY_ID,
  displayName: <FormattedMessage {...messages.processedBy} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'AssignedTo',
  shouldHideActionButtons: true,
  expectsArgumentAsArray: true,
  allowsMultipleSelection: true,
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
  actionableFilterPill: ProcessedByActionableFilterPill,
};
